var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMa = function SvgMa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.092 9.848h-5.417L12 4.695l-1.674 5.153H4.909l4.383 3.184-1.674 5.152L12 15l4.383 3.185-1.674-5.153 4.382-3.184Zm-8.573 2.785.566-1.742h1.832l.566 1.742L12 13.71l-1.482-1.077Zm2.059-2.785h-1.154L12 8.072l.577 1.776Zm1.793 2.14-.357-1.097h1.867l-1.51 1.098Zm-4.383-1.097L9.63 11.99l-1.51-1.098h1.867Zm-.385 4.562.577-1.776.933.678-1.51 1.098Zm3.285-1.098.934-.678.577 1.776-1.51-1.098Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMa;